export const environment = {
    production: false,
    apiUrl: 'https://api-dev.archsacsip.com/',
    gClientId: '1032244124889-uommbp1o7rqdq2mp0iquotijl3et7abc.apps.googleusercontent.com',
    // msClientId: '8bee98d5-d95b-4a3c-b4d5-ae551b53e537',
    msClientId: '03156946-b8ef-4304-8123-9254ff7b5c35',
    msRedirectUri: "https://app-dev.archsacsip.com/",
    apiKey: 'AIzaSyC3VjnGIgBlK8Ep6Wm-vVR-j1BMTMDQJpg',
};